<app-navbar></app-navbar>
<main class="main-content-container">
    <router-outlet></router-outlet>
</main>
